import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import Http from '../../../Http';

class Chofer extends FormComponent {

  componentDidMount() {

    this.FormConfig(
      { defaultUrl: 'chofer/one', saveUrl: 'chofer/save', backUrl: '/Catalogo/Choferes' },
      new Form([
        Form.Field('text', 'chofer_nombre', 'Nombre', '', [Validators.required], 6),
        Form.Field('text', 'chofer_apellido_paterno', 'Apellido Paterno', '', [Validators.required], 6),
        Form.Field('text', 'chofer_apellido_materno', 'Apellido Materno', '', [Validators.required], 6),
        Form.Field('text', 'chofer_rfc', 'RFC', '', [Validators.required, Validators.rfc_fisica], 6),
        Form.Field('text', 'chofer_numero_licencia', 'Numero de Licencia', '', [Validators.required], 6),
        Form.Section('Domicilio'),
        Form.Field('text', 'chofer_calle', 'Calle', '', [Validators.required], 6),
        Form.Field('text', 'chofer_numero', 'Numero Exterior', '', [Validators.required], 6),
        Form.Field('number', 'codigo_postal', 'Codigo Postal', '', [Validators.required], 6),
        Form.Field('select', 'chofer_id_colonia', 'Colonia', '', [Validators.required], 6),
        Form.Field('select', 'ciudad', 'Ciudad', '', [Validators.required], 6),
        Form.Field('select', 'estado', 'Estado', '', [Validators.required], 6),
      ],
        ['Guardar'], 'Chofer'), this.formData)

    if (this.props.match.params.id && !this.props.modal) {
      this.LoadPreds(this.props.match.params.id);
    }
  }

  formData = async (form) => {
    let Res = await Http.get(`cliente/form-generales?${(this.formEstado) ? `e=${this.formEstado}&` : ''}${(this.formCp) ? `cp=${this.formCp}&` : ''}`);
    if (!Res.error) {
      let newForm = Form.FieldOptions(form, 'estado', Res.data.estados, 'id', 'estado');
      if (Res.data.ciudades) newForm = Form.FieldOptions(newForm, 'ciudad', Res.data.ciudades, 'id', 'ciudad');
      if (Res.data.direccion) {
        const { direccion } = Res.data;
        newForm = Form.FieldOptions(newForm, 'chofer_id_colonia', direccion.colonias, 'id', 'colonia');
        newForm = Form.FieldOptions(newForm, 'ciudad', direccion.ciudades, 'id', 'ciudad');
        newForm = Form.Patch(newForm, { estado: direccion.estado.id, ciudad: direccion.ciudad.id });
        newForm = Form.FieldMod(newForm, 'estado', 'Disabled', true);
        newForm = Form.FieldMod(newForm, 'ciudad', 'Disabled', true);
      }
      newForm = Form.ValueChange(newForm, {
        codigo_postal: this.cpChange 
      });
      return newForm;
    }
  }

  cpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  onSubmit = async (i, vals) => {
    if (!this.props.modal) {
      vals.id = this.props.match.params.id;
    }
    let Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, });
      if (this.props.back && !this.props.modal) {
        this.props.history.push(`${this.config.backUrl}`);
      }
      if (!!this.props.onSave) {
        this.props.onSave(Res.data);
      }
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar: ${Res.errMsg}`, sbOpen: true });
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Chofer);